import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

export const responseSchema = z.object({
	documents: z.array(z.object({ memberId: z.string(), documentUrl: z.string() })),
});

const getGeneratedDocument = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/document/:encryptedJourneyId/generated-documents',
		method: 'GET',
		responseSchema,
		requestParameters: { encryptedJourneyId: ['required', 'string'], documentType: ['required', 'number'] },
	});

export type getGeneratedDocumentResponse = TypeOfAPIResponse<ReturnType<typeof getGeneratedDocument>>;

export type getGeneratedDocumentError = TypeOfAPIError<ReturnType<typeof getGeneratedDocument>>;

export default getGeneratedDocument;
